import React, { useContext, useEffect, useRef, useState } from "react";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import { HighlightOff, HowToReg } from "@material-ui/icons";
import { CheckCircleOutline, RadioButtonUnchecked } from "@mui/icons-material";
import * as Yup from "yup";
import { BrandContext } from "../../../contexts/BrandContext";
import BasicInputField from "../form/BasicInputField";
import { getValidationFromFields, initialValues } from "../form/FormUtilities";
import { TaxiBookingContext } from "./BookTaxiContext";
import { serializePassenger } from "./BookTaxiUtilities";
import { cLog } from "../CustomLogger";
import BlurHandler from "./BlurHandler";

export default function PassengerSetter(props){

    const taxiBookingContext = useContext(TaxiBookingContext);
    const brandContext = useContext(BrandContext);
    
    const {
        focusKey='',
        setFocus,
        removePassengerAtIndex,
        focusIndex
    } = taxiBookingContext;

    

    const {
        textContent:{
            passengerLabel='',
            removePassengerButton='',
            widget_saveButton:save=''
        },
    } = brandContext;

    const {
        bookingHook='',
        slideIndex=0
    } = props;

    
    const isFocused = ((bookingHook === focusKey) && (slideIndex === focusIndex));

    const formFields = {
        'existingOrNew':{
            label:"existingOrNewPassenger",
            type: 'radioButton',
            options:[
                {
                    value:'1',
                    label:'existingLabel'
                },
                {
                    value:'2',
                    label:'newLabel'
                },
            ],
            default:'1',
            'required': false,
        },
        'knownPassenger':{
            label:'passengerNameLabel',
            type: 'typeahead',
            apiLookupPath:'/knownpassengers/',
            optionTemplate:(option) => `${option.label}`,
            default:null,
            'required': false,
        },
        'firstName': {
            'label': 'driversWidget_firstName',
            'required': false,
        },
        'lastName': {
            'label': 'driversWidget_lastName',
            'required': false,
        },
        'mobile': {
            'label': 'driversWidget_mobile',
            'type':'telephone',
            'required': true,
        },
        'email': {
            'label': 'driversWidget_email',
            'required': false,
        },
    
        
    }
    const bookingDataObject = taxiBookingContext.bookingData[bookingHook][slideIndex]
    const {isSubmitted} = bookingDataObject;


    const sectionReady = (formik) => {
        const{
            errors
        } = formik;
        if((Object.keys(errors).length === 0) && isSubmitted){
            return true;
        }
        return false;
    }
    const phoneRegExp = /^\+?(\d{1,4})?[-.\s]?(\(?\d{1,4}\)?[-.\s]?)?(\d{1,4}[-.\s]?){1,4}\d{1,4}$/;
    const validationSchema = Yup.object().shape({
        existingOrNew: Yup.string().required('This field is required'),
        knownPassenger: Yup.mixed().nullable().when('existingOrNew', {
          is: '1',
          then: Yup.mixed().required('A passenger must be selected'),
        }),
        firstName: Yup.string().ensure().when('existingOrNew', {
          is: '2',
          then: Yup.string().required('A firstname atleast is required for a passenger'),
        }),
        mobile: Yup.string()
        .nullable() // Allow it to be null unless conditionally required
        .when('existingOrNew', {
            is: '2',
            then: Yup.string()
                .required('Mobile number is required when creating a new passenger')
                .matches(
                    phoneRegExp,
                    "Phone number is not valid, please include the area code"
                ),
            otherwise: Yup.string().nullable() // Optional or no validation otherwise
        }),
      });

      const {
        name:passengerName='',
        mobile:passengerMobile='',
        email:passengerEmail=''
      } = serializePassenger(bookingDataObject.data);

    return (
        <Formik
                initialValues={initialValues(formFields)}
                validationSchema={validationSchema}
                onSubmit={(values)=>{
                    
                    bookingDataObject.data = values
                    bookingDataObject.isSubmitted = true;
                    taxiBookingContext.setState({
                        focusKey:''
                    });
                    taxiBookingContext.checkTaxiAvailability();
                }}
            >
            {formikProps => (
                <BlurHandler formikProps={formikProps} {...props}>
                <Card 
                    variant="outlined" 
                    className={`${isFocused && 'sectionFocused'} ${sectionReady(formikProps) && 'sectionReady'} lightBox sectionBox formContainer`} 
                    onFocus={()=>{
                        if(!isFocused){
                            setFocus(bookingHook)
                        }
                    }}
                    onClick={()=>{
                        if(!isFocused){
                            setFocus(bookingHook,slideIndex)
                        }
                    }}
                >
                    {isFocused ?    
                        <Box>
                            <form onSubmit={formikProps.handleSubmit}>
                                <Grid container spacing={3}>
                                <>
                                    <Grid item xs={12} md={12}>
                                        <BasicInputField
                                            sx={{width:'100%'}}  
                                            formik={formikProps}
                                            formFields={formFields} 
                                            fieldName="existingOrNew"
                                            className="boldLabel"
                                        />    
                                    </Grid>
                                    {formikProps.values.existingOrNew === '1' &&
                                        <Grid item xs={12} md={12} className="boxyAutoComplete">
                                            <BasicInputField
                                                sx={{
                                                    width:'100%'}}  
                                                
                                                formik={formikProps}
                                                formFields={formFields} 
                                                fieldName="knownPassenger"
                                                
                                            />    
                                        </Grid>
                                    }
                                    {formikProps.values.existingOrNew === '2' &&
                                        <>
                                            <Grid item xs={12} md={12}>
                                                <BasicInputField
                                                    sx={{
                                                        width:'100%'}}  
                                                    
                                                    formik={formikProps}
                                                    formFields={formFields} 
                                                    fieldName="firstName"
                                                />    
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <BasicInputField
                                                    sx={{
                                                        width:'100%'}}  
                                                    
                                                    formik={formikProps}
                                                    formFields={formFields} 
                                                    fieldName="lastName"
                                                />    
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <BasicInputField
                                                    sx={{
                                                        width:'100%'}}  
                                                    
                                                    formik={formikProps}
                                                    formFields={formFields} 
                                                    fieldName="mobile"
                                                />    
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <BasicInputField
                                                    sx={{
                                                        width:'100%'}}  
                                                    
                                                    formik={formikProps}
                                                    formFields={formFields} 
                                                    fieldName="email"
                                                />    
                                            </Grid>
                                        </>
                                    }
                                    </>
                                </Grid>
                            </form>        
                        </Box>
                    :
                    <Box className="sectionSummary">
                        {sectionReady(formikProps) ?
                            <Box className="iconContainer iconReady"><CheckCircleOutline/></Box>
                        :
                            <Box className="iconContainer"><RadioButtonUnchecked/></Box>
                        }
                        <Box>
                            <Typography variant="subtitle1">{passengerLabel} {passengerName}</Typography>
                            <Typography className="smallText">{passengerMobile}</Typography>
                            <Typography className="smallText">{passengerEmail}</Typography>
                        </Box>
                    </Box>
                    }
                    <Box className="dialogueSectionToolsContainer">
                        {isFocused &&
                            <Button 
                                size="small"    
                                startIcon={<HowToReg/>}
                                variant="contained"
                                type="submit"
                                onClick={()=>{formikProps.handleSubmit()}}
                                >
                                {save}
                            </Button>
                        }
                        {slideIndex > 0  &&
                            <Button 
                                size="small"    
                                startIcon={<HighlightOff/>}
                                variant="contained"    
                                onClick={()=>{
                                    removePassengerAtIndex(slideIndex)
                            }}>
                                {removePassengerButton}
                            </Button>
                        }
                    </Box>
                </Card>      
                </BlurHandler>         
            )}
        </Formik>
    );

    


}

